<template>
  <InstitutionalHome />
</template>

<script setup lang="ts">
definePageMeta({
  layout: false
})

const { applyToHead } = useSeoLocale({
  pageType: 'home'
})

applyToHead()
</script>
